import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const passwordResetSearchSchema = z.object({
  code: z.string(),
});

export type PasswordResetSearch = z.infer<typeof passwordResetSearchSchema>;

export const Route = createFileRoute('/auth/reset/password/')({
  head: () => ({
    meta: [{ title: 'Redefinir Senha' }],
  }),
  validateSearch: (search) => passwordResetSearchSchema.parse(search),
});
